import {Button, Drawer, DrawerProps, message, Space, Spin} from 'antd';
import React, {useRef} from 'react';
import TableRender, {ProColumnsType, TableContext} from 'table-render';
import useRequestFn from 'Utils/Hooks/useRequestFn';
import useTable from 'Utils/Hooks/useTable';
import Style from './index.module.scss';
import {PlusOutlined} from '@ant-design/icons';
import useModalHandler from 'Utils/Hooks/useModalHandler';
import EditModal from './Components/EditModal';
import {errorMessage} from 'Utils/common';
import DeleteConfirm from 'Components/DeleteConfirm';
import {useDict} from '../../../../store';
import {deleteOperate, getOperatePage, OperateList} from './service';

interface Props extends DrawerProps {
    onOk: () => void;
    catid: string;
}

const Index = ({onOk, catid, ...props}: Props) => {
    const dict = useDict();
    const {tableInit} = useTable(getOperatePage, {data: {catid}});
    const tableRef = useRef<TableContext>(null);
    const editModal = useModalHandler({
        component: EditModal,
    });

    const [deleteAction, {loading: deleteLoading}] =
        useRequestFn(deleteOperate);

    function reload() {
        tableRef?.current?.refresh();
    }

    async function onDelete(id: string) {
        try {
            await deleteAction(id);
            await reload();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    const columns: ProColumnsType<OperateList> = [
        {
            title: '操作名称',
            dataIndex: 'actionName',
        },
        {
            title: '页面类型',
            dataIndex: 'pageType',
            width: 160,
            render: dict.OperateType.getName,
        },
        {
            title: '操作值',
            dataIndex: 'actionValue',
        },
        {
            title: '操作Xpath',
            dataIndex: 'actionXpath',
        },
        {
            title: '操作',
            fixed: 'right',
            dataIndex: 'id',
            width: 160,
            align: 'center',
            render: (id: string, data) => (
                <Space>
                    <Button
                        size="small"
                        type="link"
                        onClick={() => {
                            editModal.open({
                                data,
                                catid,
                                onOk: () => {
                                    editModal.close();
                                    reload();
                                },
                            });
                        }}>
                        修改
                    </Button>
                    <DeleteConfirm onSuccess={() => onDelete(id)}>
                        <Button size="small" type="link">
                            删除
                        </Button>
                    </DeleteConfirm>
                </Space>
            ),
        },
    ];

    const schema = {
        type: 'object',
        labelWidth: 100,
        properties: {
            actionName: {
                title: '操作名称',
                type: 'string',
            },
        },
    };

    const toolBar = (
        <div className={Style.toolBar}>
            <Space>
                <Button
                    type="primary"
                    onClick={() =>
                        editModal.open({
                            catid,
                            onOk: () => {
                                editModal.close();
                                reload();
                            },
                        })
                    }
                    icon={<PlusOutlined />}>
                    新增
                </Button>
            </Space>
        </div>
    );

    return (
        <Drawer
            title="操作设置"
            className={Style.root}
            {...props}
            onClose={onOk}
            width="90%">
            <Spin spinning={deleteLoading}>
                <TableRender
                    rowKey="id"
                    ref={tableRef}
                    columns={columns}
                    search={{schema, column: 4}}
                    toolbarRender={toolBar}
                    scroll={{x: 'max-content'}}
                    {...tableInit()}
                />
            </Spin>
            {editModal.render()}
        </Drawer>
    );
};

export default Index;
